<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M10 3.5C12.2091 3.5 14 5.29086 14 7.5V8H15.5V10.5H14V15H2V10.5H0.5V8H2V7.5C2 5.29086 3.79086 3.5 6 3.5H10ZM6 5C4.61929 5 3.5 6.11929 3.5 7.5V13.5H12.5V7.5C12.5 6.11929 11.3807 5 10 5H6ZM6 8C6.69036 8 7.25 8.55964 7.25 9.25C7.25 9.94036 6.69036 10.5 6 10.5C5.30964 10.5 4.75 9.94036 4.75 9.25C4.75 8.55964 5.30964 8 6 8ZM10 8C10.6904 8 11.25 8.55964 11.25 9.25C11.25 9.94036 10.6904 10.5 10 10.5C9.30964 10.5 8.75 9.94036 8.75 9.25C8.75 8.55964 9.30964 8 10 8ZM8 0.5C8.93164 0.500056 9.71234 1.13774 9.93457 2H6.06543C6.28764 1.13773 7.06836 0.50007 8 0.5Z"
    fill="currentColor"
  />
</svg>
